import { RowInterface } from 'common/components/entities/Row/types/RowInterface'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createRow(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
  options?: Partial<RowInterface>,
) {
  const row: RowInterface = {
    ...generateBaseEntity(EntityTypeEnum.Row, parentId, masterBlockId),
    background: {},
    padding: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
    mobilePadding: {
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 5,
      paddingRight: 5,
    },
    childIds: [],
    ...options,
  }

  return row
}
